// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwPanel from 'viewmodel/AwPanelViewModel';
import AwBackButton from 'viewmodel/AwBackButtonViewModel';
import AwSearchBox from 'viewmodel/AwSearchBoxViewModel';
import AwList from 'viewmodel/AwListViewModel';
import AwDefaultCell from 'viewmodel/AwDefaultCellViewModel';
import AwPanelFooter from 'viewmodel/AwPanelFooterViewModel';
import AwButton from 'viewmodel/AwButtonViewModel';
import AwI18n from 'viewmodel/AwI18nViewModel';
    

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/DesTeamMembersService', () => import('js/DesTeamMembersService'));
registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/desCatalogEventBus', () => import('js/desCatalogEventBus'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "props": {
        "sub-panel-context": {
            "type": "object"
        },
        "accsessionid": {
            "type": "string"
        },
        "collaborationspaceid": {
            "type": "string"
        }
    },
    "data": {
        "searchBox": {
            "displayName": "Search Users",
            "type": "STRING",
            "dbValue": ""
        },
        "searchBoxPlaceHolder": {
            "dbValue": "{{i18n.searchString}}"
        },
        "backCommand": "aw_backCommandAnchor",
        "members": [],
        "skip": 0,
        "limit": 10
    },
    "dataProviders": {
        "performSearchMultipleSelection": {
            "action": "getUsers",
            "response": "{{data.searchResults}}",
            "totalFound": "{{data.totalFound}}",
            "selectionModelMode": "multiple"
        }
    },
    "actions": {
        "reveal": {
            "actionType": "dataProvider",
            "method": "performSearchMultipleSelection"
        },
        "getTeamMembers": {
            "actionType": "JSFunction",
            "method": "getTeamMembers",
            "inputData": {
                "vmo": "{{data}}",
                "membersToStore": "{{parameters.eventData}}"
            },
            "deps": "js/DesTeamMembersService"
        },
        "getUsers": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "accsessionid": "{{props.accsessionid}}",
                            "searchInput": "{{data.searchBox.dbValue}}",
                            "collaborationspaceid": "{{props.collaborationspaceid}}",
                            "members": "{{data.members}}"
                        },
                        "query": "query ListCollabSpaceMembers($listInput: ListInput) {listCollabSpaceMembers(listInput: $listInput) }",
                        "variables": {
                            "listInput": {
                                "searchOptions": {
                                    "skip": "{{data.skip}}",
                                    "limit": "{{data.limit}}",
                                    "outputProperties": [
                                        "*"
                                    ]
                                }
                            }
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accsessionid": "{{props.accsessionid}}"
            },
            "outputData": {
                "searchResults": "data.data.listCollabSpaceMembers.filterObj",
                "totalFound": "data.data.listCollabSpaceMembers.totalFound",
                "skip": "data.data.listCollabSpaceMembers.skip"
            },
            "events": {
                "success": [
                    {
                        "name": "searchResultsSuccess",
                        "condition": "searchResults.hasError === false",
                        "eventData": {
                            "eventName": "searchResultsSuccess",
                            "eventData": "{{searchResults}}"
                        }
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "storeData": {
            "actionType": "JSFunction",
            "method": "storeData",
            "inputData": {
                "dataProvider": "{{data.dataProviders.performSearchMultipleSelection}}",
                "sharedData": "{{props.subPanelContext.sharedData}}"
            },
            "events": {
                "success": [
                    {
                        "name": "storeData.success"
                    }
                ]
            },
            "deps": "js/DesTeamMembersService"
        },
        "doSearch": {
            "actionType": "Event",
            "method": "Event",
            "inputData": {
                "events": [
                    {
                        "name": "searchInitiated",
                        "condition": "data.searchBox.dbValue && data.searchBox.dbValue.length>0",
                        "eventData": {
                            "eventName": "searchInitiated",
                            "searchInput": "{{data.searchBox.dbValue}}"
                        }
                    }
                ]
            }
        },
        "backAction": {
            "actionType": "Event",
            "method": "Event",
            "inputData": {
                "events": [
                    {
                        "name": "backButtonClicked"
                    }
                ]
            }
        },
        "publishToACCEventBus": {
            "actionType": "JSFunction",
            "method": "publish",
            "inputData": {
                "eventId": "{{parameters.eventName}}",
                "eventData": "{{parameters.eventData}}"
            },
            "deps": "js/desCatalogEventBus"
        },
        "performBatchActionOnSearch": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "resetSkipVals"
                },
                {
                    "action": "reveal"
                }
            ]
        },
        "resetSkipVals": {
            "actionType": "JSFunction",
            "method": "resetSkipVals",
            "inputData": {
                "data": "{{data}}"
            },
            "deps": "js/DesTeamMembersService"
        }
    },
    "conditions": {},
    "onEvent": [
        {
            "eventId": "searchInitiated",
            "action": "performBatchActionOnSearch"
        },
        {
            "eventId": "getAssignedTeamMembers.success",
            "action": "getTeamMembers",
            "inputArgs": {
                "eventName": "{{eventData.eventName}}",
                "eventData": "{{eventData.eventData}}"
            }
        },
        {
            "eventId": "performSearchMultipleSelection.selectionChangeEvent",
            "cacheEventData": true,
            "action": "publishToACCEventBus",
            "inputArgs": {
                "eventName": "userListSelectionChangeCreateTeam",
                "eventData": "{{eventData.selectedObjects}}"
            }
        }
    ],
    "i18n": {
        "searchString": [
            "DesTeamMessages"
        ],
        "addButton": [
            "DesTeamMessages"
        ],
        "addTeamMembersTitle": [
            "DesTeamMessages"
        ]
    },
    "_viewModelId": "DesCreateTeamSubPanel",
    "_uniqueViewModelId": "DesCreateTeamSubPanel",
    "ctx": {}
};

    /*
    <aw-panel>
    <aw-back-button title="i18n.addTeamMembersTitle" action='backAction'></aw-back-button>
    <aw-search-box prop="data.searchBox" placeholder="data.searchBoxPlaceHolder.dbValue" action="doSearch">
    </aw-search-box>
    <aw-list dataprovider="data.dataProviders.performSearchMultipleSelection">
        <aw-default-cell vmo="item"> </aw-default-cell>
    </aw-list>
    <aw-panel-footer>
        <aw-button type='button' action='actions.storeData'>
            <aw-i18n>{{i18n.addButton}}</aw-i18n>
        </aw-button>
    </aw-panel-footer>
</aw-panel>
    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
                <AwPanel  revealAction={actions.reveal}>
        <AwBackButton title={i18n.addTeamMembersTitle} action={actions.backAction}>
        </AwBackButton>
        <AwSearchBox {...getField("data.searchBox", fields, $index, null, null )} placeholder={AwParseService.instance( "data.searchBoxPlaceHolder.dbValue" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} action={actions.doSearch}>
        </AwSearchBox>
        <AwList dataprovider={dataProviders.performSearchMultipleSelection} showDropArea={null} dndHandler={props.viewModel.dndHandler}>{({item, index})=>{ return <>            <AwDefaultCell vmo={AwParseService.instance( "item" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports, item, index } )}>
            </AwDefaultCell></> } }
        </AwList>
        <AwPanelFooter>
            <AwButton type="button" action={AwParseService.instance( "actions.storeData" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                <AwI18n>
                    {AwParseService.instance( "i18n.addButton" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}
                </AwI18n>
            </AwButton>
        </AwPanelFooter>
    </AwPanel>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;